export default __webpack_public_path__ + "static/media/2.56f60cc5.png";